import { take } from 'rxjs/operators';
import { StatusAccodionEnum } from './../../../shared/general-timeline-accordion/model/status-accordion.enum';
import { Component, OnInit, Input } from '@angular/core';
import {
  StatusSignatureByPerson,
  StatusSignatureByDocument,
} from './model/status-signature.interface';
import { FichaService } from '../../ficha-veiculo.service';

@Component({
  selector: 'app-timeline-status-signature',
  templateUrl: './timeline-status-signature.component.html',
  styleUrls: ['./timeline-status-signature.component.scss'],
})
export class TimelineStatusSignatureByDocumentComponent implements OnInit {
  @Input() public propostaId: number;
  public statusAccodionEnum = StatusAccodionEnum;
  public status: StatusSignatureByDocument;
  public statusSignatureByPerson: StatusSignatureByPerson[] = [];

  constructor(private fichaService: FichaService) {}

  ngOnInit() {
    this.getStatus();
  }

  getStatus() {
    this.fichaService
      .getSignStatus(this.propostaId)
      .pipe(take(1))
      .subscribe(
        (status: StatusSignatureByDocument) => {
          if (status) {
            this.status = status;
            this.statusSignatureByPerson = this.mapStatusSignatureByPerson(
              this.status
            );
          }
        },
        (error) => {
          this.status = undefined;
          this.statusSignatureByPerson = undefined;
        }
      );
  }

  getGeneralStatusByStatusSignatureByDocument(
    status: StatusSignatureByDocument
  ): StatusAccodionEnum {
    const isAllSigned = status.signEnvelopeResponses.every(
      (signEnvelopeResponse) =>
        signEnvelopeResponse.signatarioResponse.every(
          (item) => item.signed === true
        ) === true
    );

    const isAllNotSigned = status.signEnvelopeResponses.every(
      (signEnvelopeResponse) =>
        signEnvelopeResponse.signatarioResponse.every(
          (item) => item.signed === false
        ) === true
    );

    return isAllSigned
      ? StatusAccodionEnum.FINALIZADO
      : isAllNotSigned
      ? StatusAccodionEnum.PENDENTE
      : StatusAccodionEnum.EM_ANDAMENTO;
  }

  getGeneralStatusByStatusSignatureByPerson(
    StatusSignatureByPerson: StatusSignatureByPerson
  ): StatusAccodionEnum {
    const isAllSigned = StatusSignatureByPerson.signEnvelopeResponses.every(
      (signEnvelopeResponse) => signEnvelopeResponse.signed === true
    );

    const isAllNotSigned = StatusSignatureByPerson.signEnvelopeResponses.every(
      (signEnvelopeResponse) => signEnvelopeResponse.signed === false
    );

    return isAllSigned
      ? StatusAccodionEnum.FINALIZADO
      : isAllNotSigned
      ? StatusAccodionEnum.PENDENTE
      : StatusAccodionEnum.EM_ANDAMENTO;
  }

  mapStatusSignatureByPerson(
    documentSignatario: StatusSignatureByDocument
  ): StatusSignatureByPerson[] {
    let persons: StatusSignatureByPerson[] =
      this.getPersons(documentSignatario);

    persons = persons.map((person) => {
      documentSignatario.signEnvelopeResponses.forEach((document) => {
        if (
          document.signatarioResponse.some(
            (item) => item.clientUserId === person.clientUserId
          )
        ) {
          person.signEnvelopeResponses.push({
            envelopeId: document.envelopeId,
            message: document.message,
            signed: document.signatarioResponse
              .filter((item) => item.clientUserId === person.clientUserId)
              .every((item) => item.signed === true),
            status: document.status,
            documentoDescricao: document.documentoDescricao,
          });
        }
      });
      return person;
    });

    return persons;
  }

  getPersons(
    documentSignatario: StatusSignatureByDocument
  ): StatusSignatureByPerson[] {
    const persons: StatusSignatureByPerson[] = [];
    documentSignatario.signEnvelopeResponses.forEach((signEnvelopeResponse) => {
      signEnvelopeResponse.signatarioResponse.forEach(
        (signEnvelopeResponse) => {
          const person: StatusSignatureByPerson = {} as StatusSignatureByPerson;
          person.celular = signEnvelopeResponse.celular;
          person.clientUserId = signEnvelopeResponse.clientUserId;
          person.ddd = signEnvelopeResponse.ddd;
          person.email = signEnvelopeResponse.email;
          person.id = signEnvelopeResponse.id;
          person.nome = signEnvelopeResponse.nome;
          person.signed = signEnvelopeResponse.signed;
          person.signEnvelopeResponses = [];
          if (
            persons.every((item) => item.clientUserId !== person.clientUserId)
          ) {
            persons.push(person);
          }
        }
      );
    });

    return persons;
  }
}
